import { useCallback } from 'react'

import { isNil } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { useAuthStore } from '../useStore'

export const useHasPermissionFn = () => {
  const { permissions, administrator, superAdministrator } = useAuthStore(
    state => pick(state, ['permissions', 'administrator', 'superAdministrator'])
  )

  const hasPermission = useCallback(
    (permission?: string, onlyAdministrator?: boolean) => {
      if (superAdministrator || isNil(permission)) {
        return true
      }
      if (onlyAdministrator) {
        return !!(administrator || superAdministrator)
      }
      return permissions.includes(permission)
    },
    [permissions, administrator, superAdministrator]
  )

  return hasPermission
}
